module.exports = __webpack_public_path__ + "static/media/crossIconLight.06195568.svg";